import requests from './request'
// 登录
export const login = async (data)=>{
    return await requests('Login/Login',data,'post',1)
}

//注册用户
export const register = async (data)=>{
    return await requests('Login/RegisterUser',data,'post',1)
}
// 修改用户信息
export const UpdateInfo = async (data)=>{
    return await requests('Users/UpdateInfo',data,'post',1)
}

//修改密码
export const UpdatePwd = async (data)=>{
    return await requests('Users/UpdatePwd',data,'post',1)
}

//注册管理站
export const InsertSite = async (data)=>{
    return await requests('Login/InsertSite',data,'post',1)
}

//根据token获取登陆用户信息
export const GetUser = async (data)=>{
    return await requests('Users/GetUserByToken',data,'post',1);
}

// 获取用户列表
export const GetUserList = async (data)=>{
    return await requests('Users/GetUserList?where='+data.where+'&skip='+data.skip+'&take='+data.take,data,'GET',0);
}
// 获取用户信息
export const GetUserByID = async (param)=>{
    return await requests('Users/GetUserByID',param,'GET',0);
}

// 删除用户
export const DeleteByID = async (param)=>{
    return await requests('Users/DeleteByID/'+param,param,'POST',1);
}